<template>
  <div class="flex flex-col h-screen ">
    <!-- <the-navbar class="print:hidden" /> -->
    <div
      class="flex-1 h-full drawer"
      :class="{ 'drawer-mobile': showSidebar }"
    >
      <input
        id="the-drawer"
        type="checkbox"
        class="drawer-toggle"
      >
      <div class="flex flex-col drawer-content">
        <slot />
      </div>
      <div
        v-if="showSidebar"
        class="drawer-side print:hidden"
      >
        <!-- The tap-outside-to-close overlay is a mobile-only affordance
             tied to the (unused, for a collapsible sidebar) checkbox — it
             would otherwise paint a dark scrim behind the menu, so it's
             only wired up for the default, non-collapsible sidebar. -->
        <label
          v-if="!collapsible"
          for="the-drawer"
          class="drawer-overlay"
        />
        <!-- `.drawer-side`'s own CSS grid stretches whichever single element
             sits directly inside it to the full sidebar height — a wrapping
             div (a plain block box that just sizes to its own content)
             would leave the dark background short of the bottom, so the
             drawer stays its direct (and only) child. -->
        <the-drawer v-if="!admin" />
        <the-admin-drawer
          v-if="admin"
          :admin="true"
        />
      </div>

      <!-- Both tabs float OUTSIDE .drawer-side (not embedded in its own
           content) and are `position:fixed`, so neither .drawer's own
           overflow:hidden nor .drawer-side's overflow-y:auto clips them —
           mirror images of each other, one shown at a time. -->
      <button
        v-if="collapsible && !sidebarOpen"
        class="sidebar-tab sidebar-tab--open"
        title="Show menu"
        @click="sidebarOpen = true"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="13"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        ><polyline points="9 6 15 12 9 18" /></svg>
        <span>Menu</span>
      </button>
      <button
        v-if="collapsible && sidebarOpen"
        class="sidebar-tab sidebar-tab--close"
        title="Hide menu"
        @click="sidebarOpen = false"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="13"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        ><polyline points="15 6 9 12 15 18" /></svg>
        <span>Menu</span>
      </button>
    </div>
  </div>
</template>

<script>
import TheDrawer from '@/components/TheDrawer.vue'
import TheAdminDrawer from '@/components/AdminDrawer.vue'
export default {
  components: {
    TheDrawer,
    TheAdminDrawer
  },
  props: {
    admin: {
      type: Boolean,
      required: false,
      default: false
    },
    // Opts a page into a collapsible nav sidebar that starts closed, with an
    // edge tab to reopen it — instead of the default always-visible sidebar.
    collapsible: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      // Only meaningful when `collapsible` — starts closed either way.
      sidebarOpen: false
    }
  },
  computed: {
    showSidebar () {
      return !this.collapsible || this.sidebarOpen
    }
  }
}
</script>

<style>
/* Shared look for both the reopen tab (screen's left edge, sidebar closed)
   and the close tab (sidebar's right edge, sidebar open) — one floating
   affordance, mirrored, never embedded in the sidebar's own content. Both
   are `position:fixed` (not relative to .drawer-side) so neither .drawer's
   overflow:hidden nor .drawer-side's own overflow-y:auto clips them. */
.sidebar-tab {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  z-index: 50;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  background: #eef0f3;
  border: 1px solid #d7dae0;
  border-left: none;
  color: #46634F;
  cursor: pointer;
  border-radius: 0 11px 11px 0;
  padding: 14px 6px;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.07);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  transition: background-color 0.15s, padding-left 0.15s;
}
.sidebar-tab:hover {
  background: #e2e5ea;
  padding-left: 10px;
}
.sidebar-tab span {
  writing-mode: vertical-rl;
}

.sidebar-tab--open {
  left: 0;
}

.sidebar-tab--close {
  /* Matches .capacio-logo's width (drawer.scss) — the widest sidebar
     content, which is what actually determines its rendered (max-content)
     column width. */
  left: 220px;
}
</style>
